/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Calculation } from "./Calculation";
export const CalculationResponse = core.serialization.object({
    data: Calculation,
});
